import { Component, input } from '@angular/core';

@Component({
  selector: 'app-transport-group-chips',
  imports: [],
  templateUrl: './transport-group-chips.component.html',
  styleUrl: './transport-group-chips.component.scss',
})
export class TransportGroupChipsComponent {
  groups = input.required<string[]>();
}
